import { products, type Product } from "../data/products";
import ProductCard from "../components/ProductCard";

export default function Products() {
  return (
    <>
      <nav className="breadcrumbs">Accueil / Produits</nav>
      <h1>Produits</h1>
      <div className="grid" style={{ marginTop: 12 }}>
        {products.map((product: Product) => (
          <ProductCard key={product.sku} productSpecific={product}
          />
        ))}
      </div>
    </>
  );
}
